import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ContactModal } from '../modal/contact-modal';
import { contactParamConfigModel } from '../modal/contact-param-config-model';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

@Component({
  selector: 'app-contact-add-update',
  templateUrl: './contact-add-update.component.html',
  styleUrls: ['./contact-add-update.component.css'],
})
export class ContactAddUpdateComponent implements OnInit {
  public submitted: boolean = false;
  public formGroupContact: FormGroup;
  public moduleParam: contactParamConfigModel = new contactParamConfigModel(this.moduleService);

  @Input()
  public data: ContactModal;

  @Output('onSave')
  public saveCallback: EventEmitter<ContactModal> = new EventEmitter<ContactModal>();

  @Output('onCancel')
  public cancelCallback: EventEmitter<ContactModal> = new EventEmitter<ContactModal>();
  constructor(private formBuilder: FormBuilder, private moduleService: ModuleParamGlobConfigService) {}

  ngOnInit() {
    this.setValidation();
  }

  setValidation() {
    this.formGroupContact = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNo: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern(/^(\+\d{1,3}[- ]?)?\d{10}$/)])
      ),
      email: ['', Validators.email],
    });
  }
  get f() {
    return this.formGroupContact.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroupContact.invalid) {
      return;
    }

    this.saveCallback.emit(this.data);
  }

  _keyUp(event: any) {
    const pattern = /[0-9\.]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && event.keyCode != 9 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onCancel() {
    this.cancelCallback.emit(this.data);
  }
}
